import React, {Component} from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'

import Button from '@material-ui/core/Button'

/**
 * selected
 * 
 * onDeleteClick
 * onCancelClick
 */

class DeleteTemplateDialog extends Component {

	render() {

		return <Dialog open scroll = "body">
			<DialogTitle>Удалить шаблон закупки?</DialogTitle>
			<DialogContent>
				Вы уверены, что ходите удалить {this.props.selected.type ? "шаблон закупки" : "папку"} &laquo;{this.props.selected.name}&raquo;?
			</DialogContent>
			<DialogActions>
				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onDeleteClick === "function") {
							this.props.onDeleteClick(this.props.selected)
						}
					}}
				>Удалить</Button>
				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCancelClick === "function") {
							this.props.onCancelClick()
						}
					}}
				>Отмена</Button>
			</DialogActions>
		</Dialog>
	}

}

export default DeleteTemplateDialog